export default {
  production: false,
  useEmulators: false,
  firebase: {
    apiKey: "AIzaSyBrXaQE71ptTK6BdRcn2639x-HObWRfAsM",
    authDomain: "nft-dev-b6c9c.firebaseapp.com",
    databaseURL: "https://nft-dev-b6c9c-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "nft-dev-b6c9c",
    storageBucket: "nft-dev-b6c9c.appspot.com",
    messagingSenderId: "311453738207",
    appId: "1:311453738207:web:6abb4ba959ddf1357ef56a",
    measurementId: "G-YHDBEKETNL",
  },
  eth: {
    erc1155: '0x700550a4cdf6fb4e6d5ee0adf7d677b535709cec',
    network: 'goerli',
  }
}
